import { FileSignature, Gavel, Mail, Stamp } from 'lucide-react';
import type { FeatureContent } from './types';
import { russoTestimonial2 } from '@/content/testimonials';

export const redazioneDocumenti: FeatureContent = {
  slug: 'redazione-documenti',
  navLabel: 'Redazione di atti e documenti',
  menuDescription:
    'Parti dal caso e dagli allegati per generare bozze di atti, contratti e documenti professionali.',
  cardDescription:
    'Parti dal caso e dagli allegati: Trovanorma organizza fatti, contenuti e riferimenti in una prima bozza da rivedere e completare.',
  meta: {
    title: 'Redazione di atti giudiziali e stragiudiziali con AI',
    description:
      'Memorie, opposizioni, ricorsi, comparse, diffide e contratti: descrivi il caso e ricevi una bozza allineata alla normativa vigente, con norma e giurisprudenza citate per intero.',
  },
  hero: {
    title: 'Redazione di atti e documenti',
    subtitle:
      'Parti dal caso e dagli allegati: Trovanorma organizza fatti, contenuti e riferimenti in una prima bozza da rivedere e completare.',
    image: {
      src: '/images/hero/hero-avvocati.webp',
      alt: 'Trovanorma redige un documento con riferimenti normativi in un pannello affiancato alla chat',
      width: 1600,
      height: 1008,
    },
  },
  statement: 'La pagina bianca non deve essere il punto di partenza',
  statementText:
    'Dagli atti giudiziali alle comunicazioni, dai contratti ai documenti societari: parti da ciò che hai e costruisci una prima bozza già strutturata.',
  blocks: [
    {
      icon: Gavel,
      kicker: 'Atti giudiziali e difensivi',
      title: 'Parti dai fatti e dal fascicolo',
      description:
        'Memorie, ricorsi, opposizioni, comparse, querele e altri atti: Trovanorma organizza il caso in una prima bozza strutturata da rivedere.',
    },
    {
      icon: Mail,
      kicker: 'Comunicazioni e stragiudiziale',
      title: 'Dal contenuto alla comunicazione da inviare',
      description:
        'Diffide, solleciti, richieste, contestazioni e comunicazioni professionali, adattando struttura e tono al destinatario.',
    },
    {
      icon: FileSignature,
      kicker: 'Contratti e documenti societari',
      title: 'Contratti, verbali, procure e deleghe',
      description:
        'Genera una prima bozza a partire dalle informazioni del caso, dagli allegati e dalle indicazioni che fornisci.',
    },
    {
      icon: Stamp,
      kicker: 'Documenti nel formato del tuo studio',
      title: 'Il contenuto è tuo. Anche il formato.',
      description:
        'Personalizza intestazione e piè di pagina, modifica il documento e portalo in Word o PDF per continuare a lavorarci.',
    },
  ],
  steps: [
    {
      step: 1,
      title: 'Dai il contesto',
      description:
        'Indica il documento che devi preparare, i fatti rilevanti e il risultato che vuoi ottenere. Allega ciò che hai già.',
    },
    {
      step: 2,
      title: 'Trovanorma costruisce la prima versione',
      description:
        'Organizza contenuti e riferimenti in un documento strutturato, pronto per essere lavorato.',
    },
    {
      step: 3,
      title: 'Rivedi e finalizza',
      description:
        'Modifica il testo, crea nuove versioni, confronta le modifiche ed esporta il risultato in Word o PDF.',
    },
  ],
  relatedSolutions: ['avvocati', 'studi-legali', 'consulenti-del-lavoro'],
  // «restituire un testo già pronto per l'uso»: è questa pagina, detta da chi
  // la usa. Senza, qui girerebbe la citazione di riserva di FeaturePage.
  testimonial: russoTestimonial2,
  closing: {
    title: 'Per la tua prossima bozza non partire da zero',
    text: 'Porta il caso, gli allegati o un tuo modello e prova a costruire la prima versione con Trovanorma.',
  },
};
